/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import styled from "@emotion/styled";
import { colors } from "@utils/ui_palette";
import { IModule } from "@pages/AssessmentDetail";
import ImageModal from "../modal/ImageModal";

interface IPatterns {
  type: string;
  item: IModule;
  anwserCallback: (item: IModule, type: string) => Promise<void>;
}

function ImageModule({ type, item, anwserCallback }: IPatterns) {
  const [modal, setModal] = useState<boolean>(false);
  const handleModal = useCallback(
    (state: boolean) => {
      setModal(state);
    },
    [setModal]
  );

  const getQuestionState = useCallback(() => {
    if (type === "Name_the_object") {
      return (
        item.answer_submit?.toLocaleLowerCase() ===
        item.anwser.toLocaleLowerCase()
      );
    } else {
      const anwserArr = item.anwser.toLocaleLowerCase().split(",");

      const getAnwser =
        anwserArr.filter((anwser) =>
          item.answer_submit?.toLocaleLowerCase()?.includes(anwser)
        ).length || 0;

      return getAnwser === 0 ? false : true;
    }
  }, [item]);
  return (
    <>
      <Container
        key={`report-${type}-${item.id}`}
        active={getQuestionState()}
        onClick={() => handleModal(true)}
      >
        <Question>
          {type === "RC" ||
          type === "Uppercase" ||
          type === "Lowercase" ||
          type === "Write_to_10" ||
          type === "Write_to_20" ||
          type === "Write_to_30" ? (
            item.question
          ) : (
            <QuestionImage
              src={item.question_image ? item.question_image : item.question}
            />
          )}
        </Question>

        <UserAnwser>
          {(item.answer_submit && item.answer_submit.replace(/,/g, " ")) || ""}
        </UserAnwser>
      </Container>
      {modal && (
        <ImageModal
          item={item}
          type={type}
          handleModal={handleModal}
          callback={anwserCallback}
        />
      )}
    </>
  );
}

const Container = styled.div<{ active: boolean }>`
  flex-basis: 20%;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 12px;
  background-color: ${colors.White};
  border: ${(props) =>
    `${props.active ? "1px" : "2px"} solid ${
      props.active ? colors.Gray30 : colors.Error20
    };`};
  box-shadow: 5px 5px 10px ${colors.Gray30};
  margin-right: 20px;
  cursor: pointer;
`;

const Question = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  border: 1px solid ${colors.Gray30};
  border-radius: 8px;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto;
  padding: 20px;
`;

const QuestionImage = styled("img")`
  height: 100px;
`;

const UserAnwser = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.Primary50};
  font-weight: 700;
  font-size: 20px;
  margin-top: 20px;
`;

export default ImageModule;
